// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-modal .modal-content{height:calc(100vh - 160px);-webkit-box-flex:unset!important;-ms-flex:unset!important;flex:unset!important}.sideModal .v-card{background:#f2f2f7;border-radius:20px 0 0 20px!important}.sideModal .v-card:not(:first-child){margin-left:-17px;z-index:1}.sideModal .v-card:last-child{background:#e5e5ea}.sideBarPanel~.chatContent{width:484px}", ""]);
// Exports
module.exports = exports;
